import React, { useEffect, useState } from 'react';
import { Button, Form, Icon, Input, Notification, Upload } from '@alifd/next';
import Styles from './index.module.scss';
import { Servlets } from '@/service';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import utils from '@/common/utils';

export default () => {
  const FormItem = Form.Item;
  const [key, setKey] = useState();
  const [size, setSize] = useState();
  const [md5, setMd5] = useState();
  const [success, setSuccess] = useState();
  const [iconType, setIconType] = useState(1);
  // 文件名
  const [fileName, setFileName] = useState();
  // 提示弹窗
  const tips = (type, content, title) => {
    Notification.open({
      title,
      content,
      type,
    });
  };
  const history = useHistory();
  // 获得 Authorization 上传没有走service方法
  const Authorization = sessionStorage.getItem('LZ_SSO_TOKEN');
  // 获得 prod
  const prod = "dy_cjyx";

  const mergeUpload = (values, errors) => {
    if (success == true) {
      // 传入参数
      const param = {
        description: values.crowddes,
        name: values.crowdname ? values.crowdname : '',
        key,
        size,
        md5,
      };
      if (!param.name) {
        tips('error', '请输入人群名称', '错误');
      }
       else {
        // 人群合并接口
        Servlets('crowdMerge', param).then((res) => {
          if (res.data.createTime != '') {
            tips('success', '保存人群成功', '成功');
            setTimeout(() => {
              history.push('/CustomerManagement');
            }, 2000);
          } else {
            tips('error', '保存人群失败', '失败');
          }
        });
      }
    }
    else {
      tips('error', '请上传人群包', '失败');
      return false;
    }
  };


  /** 设置 Header 面包屑 */
  const setBreadcrumb = () => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '客户管理', // 一级页面名称
      url: '/web/CustomerManagement', // 一级页面url
      children: {
        name: '人群管理', // 二级页面名称
        url: '/web/CustomerManagement', // 二级页面url
        children: {
          name: '用户手机号上传', // 三级页面名称
          url: '', // 三级页面url
        },
      },
    });
  };

  const getPhoneTemplate = () =>{
    Servlets('downLoadPhoneTemplate').then((res) => {
    utils.downloadFile(
      {
        data: res.data.content,
        filename: res.data.fileName,
        resp_code: res.resp_code,
        resp_msg: res.resp_msg,
        success: res.success,
        downloadType:'txt'
      });
    })
    .catch(e => console.log(e));

  }

  useEffect(() => {
    // 设置 Header 面包屑
    setBreadcrumb();
  });
  return (
    <div style={{ padding: '0 20px' }}>
      {/* <header className={Styles.navbar}>
        <h4 className={Styles.title}>公域人群管理/用户PIN上传</h4>
      </header> */}
      <div className={Styles.listSearch}>
        <Form inline size="medium" className={Styles.listSearchForm}>
          <FormItem required label="人群名称:" className={Styles.formItem}>
            <Input
              trim
              name="crowdname"
              maxLength={32}
              aria-label="input max length 32"
              hasLimitHint
              className={Styles.formItem_width}
            />
          </FormItem>
          <FormItem label="人群描述:" className={Styles.formItem}>
            <Input
              name="crowddes"
              maxLength={32}
              defaultValue={moment().format('M月D日创建')}
              hasLimitHint
              aria-label="input max length 32"
              className={Styles.formItem_width}
            />
          </FormItem>
          <FormItem className={Styles.formItem} style={{ textAlign: 'right' }}>
            <Form.Submit
              type="primary"
              className={`${Styles.submitBtnStyle_width} ${Styles.submitBtnStyle_marginRight}`}
              onClick={mergeUpload}
            >保存人群
            </Form.Submit>

            <Button
              type="secondary"
              className={`${Styles.submitBtnStyle_width} ${Styles.submitBtnStyle_marginRight}`}
              onClick={() => {
                history.push('/CustomerManagement');
              }}
            >返回
            </Button>
          </FormItem>
          {/* </div> */}
        </Form>
      </div>
      <div className={Styles.main}>
        <div className={Styles.maintop}>
          <div className={Styles.notice}>
            <span style={{ marginLeft: '10px' }}><span className="iconfont icon-icon4-37" style={{ color: '#2d8cf0' }} /><span style={{
              fontSize: '14px',
              marginLeft: '8px',
              fontFamily: 'PingFang SC',
              fontWeight: 500,
              color: '#333333',
            }}
            >上传须知：
            </span>
            </span>
            <ul style={{ paddingLeft: '20px' }} className={Styles.text}>
              <li>1.目前只支持上传txt格式文件，上传时请仔细检查</li>
              <li>2.人群文件格式为：每行一个用户手机号</li>
              <li>3.上传手机号人群不受会员识别限制</li>
              <li>4.单次上传最大20M，上传中请不要关闭此页面</li>
            </ul>
          </div>
        </div>
        <div style={{ marginLeft: '20px', width: '690px', textAlign: 'right' }}>
          <Icon type="download" size="xs" style={{ color: '#9ca7b6', cursor: 'pointer' }} />
          <Button
            text
            onClick={()=>{getPhoneTemplate()}}
          >下载模板</Button>
        </div>
        {/* 上传文件 */}
        <Upload.Dragger
          style={{
            marginLeft: '20px',
            marginTop: '15px',
            width: '690px',
            height: '250px',
            cursor: 'pointer',
            textAlign: 'center',
          }}
          name="uploadedfile"
          listType="text"
          limit={1}
          onProgress={
            // 加载中
            () => {
              setIconType(4);
            }
          }
          beforeUpload={(file) => {
            setFileName(file.name);
            if (file.size > 20971520) {
              tips('error', '文件过大上传失败', '失败');
            }
          }}
          // 移除文件
          onRemove={(file) => {
            true;
            setIconType(1);
          }}
          method="post"
          // 添加请求头
          headers={{ prod, Authorization }}
          action="/api/crowd/phonenumberuploadfile"
          withCredentials={false}
          // 文档上说明跨域用
          // headers={{ 'X-Requested-With': null }}
          onError={(value) => {
            const errorMessage = value.originFileObj.size;
            setIconType(3);
            tips('error', '上传失败', '失败');
          }}
          onSuccess={(res) => {
            setIconType(2);
            setKey(res.response.data.key);
            setSize(res.response.data.size);
            setMd5(res.response.data.md5);
            setSuccess(res.response.success);
            tips('success', '上传成功', '成功');
          }}
        >
          <div
            className="next-upload-drag"
            style={{
              border: '1px dashed #D7DDE4',
              height: '250px',
              paddingTop: '77px',
              borderRadius: '10px',
            }}
          >
            {
              iconType === 1 ? (
                <div>
                  <span
                    className={'iconfont icon-icon2_huaban1-02'}
                    style={{
                      color: '#A69DFF',
                      fontSize: '50px',
                      fontWeight: 500,
                      fontFamily: 'PingFang SC',
                    }}
                  />
                  <div
                    className="next-upload-drag-text"
                    style={{ marginTop: '12px', color: '#5D4CFF' }}
                  >点击或将文件拖拽到这里上传
                  </div>
                  <span
                    className="next-upload-drag-hint"
                    style={{ marginTop: '10px', color: '#9CA7B6' }}
                  >支持扩展名：.txt(大小不超过20MB)
                  </span>
                </div>
              ) : (
                iconType === 2 ? (
                  <span>
                    <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                      <span className={'iconfont icon-icon4-24'} style={{ color: '#00BB66', fontSize: '32px' }} />
                      <span style={{ lineHeight: '18px', marginLeft: '11px' }}>上传成功，<span
                        className={'iconfont icon-icon5-17'}
                        style={{ color: '#657180' }}
                      /> 文件：{fileName}
                      </span>
                    </div>
                    <div>
                      {/* <Button type="normal" style={{ width: '88px', height: '30px', marginTop: '33px' }}>删除</Button> */}
                    </div>
                  </span>
                ) : (
                  iconType === 3 ? (
                    <span>
                      <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                        <span className={'iconfont icon-icon4-30'} style={{ color: '#FF3333', fontSize: '32px' }} />
                        <span style={{ lineHeight: '18px', marginLeft: '11px' }}>上传失败，上传文件与模板不符</span>
                      </div>
                      <div>
                        {/* <Button type="primary" style={{ width: '88px', height: '30px', marginTop: '33px' }}>重新上传</Button> */}
                      </div>
                    </span>
                  ) : (
                    <span>
                      <div style={{ display: 'inline-flex', textAlign: 'center' }}>
                        <Icon
                          type="loading"
                          style={{ color: '#3399FF', fontSize: '32px', width: '32px', height: '32px' }}
                        />
                      </div>
                      <div style={{
                        marginTop: '5px',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'PingFang SC',
                      }}
                      >
                        上传中...
                      </div>
                    </span>
                  )
                )
              )
            }
          </div>
        </Upload.Dragger>
      </div>
    </div>
  );
};
